import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-alpha',
  templateUrl: './icon-alpha.component.html',
  styleUrl: './icon-alpha.component.scss',
  standalone: false,
})
export class IconAlphaComponent {
  @Input() tooltip?: string;
}
